import { smoothScrollBy } from '@lemonadefashion/smooth-scroll';
import { getViewportHeight } from '@lemonadefashion/viewport';
import { getNavbarHeightPx } from './navbar_size';

export const scrollIntoView = (domElement, _offsetTopPx, rootElement = document.body, offsetBottomPx = 0) => {
  if (!domElement || !rootElement) return;
  const boundingClientRect = domElement.getBoundingClientRect();
  const offsetTopPx = _offsetTopPx || (getNavbarHeightPx() + 16);
  if (boundingClientRect.top < offsetTopPx || boundingClientRect.bottom > getViewportHeight() - offsetBottomPx) {
    const scrollDelta = boundingClientRect.top - offsetTopPx;
    if (scrollDelta) smoothScrollBy({ offsetPx: scrollDelta }, rootElement);
  }
};
